module.exports = __webpack_public_path__ + "static/media/New_banner.3077150a.svg";